<h4 mat-dialog-title>
  <span *ngIf="!data; else editHeader">
    Creazione nuovo annuncio
  </span>
  <ng-template #editHeader>
    Modifica annuncio {{ data?.titolo }}
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-2" (keydown.enter)="edit()">
  <mat-form-field appearance="fill">
    <mat-label>Titolo</mat-label>
    <input matInput formControlName="titolo" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="no-bottom-padding">
    <mat-label>Contenuto</mat-label>
    <textarea matInput rows="6" formControlName="contenuto"></textarea>
  </mat-form-field>
</form>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="dialogRef.close()">Annulla</button>
  <button mat-flat-button color="primary" (click)="edit()" [disabled]="form.invalid">Salva</button>
</mat-dialog-actions>
